import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import { useUserStore } from '@/store/userStore';
import { cashService } from '../../services/cashService';

export const useGetBalance = options => {
  const accessToken = useUserStore(state => state.accessToken);

  return useQuery({
    ...options,
    enabled: Boolean(accessToken) && (options?.enabled ?? true),
    refetchInterval: 60000,
    refetchIntervalInBackground: false,
    retry: (count, error) => {
      if (error?.response?.status === 401) return false;
      return count < 3;
    },
    retryDelay: attempt => Math.min(1000 * attempt, 5000),
    queryKey: [QUERY_KEYS.cash.balance],
    queryFn: async () => {
      const response = await cashService.balance();
      if (response.status !== 200) {
        throw new Error('Balance fetch failed');
      }
      return response.data;
    },
  });
};
